const jsonLogic = require('json-logic-js');
const { differenceBy, filter, find, flatten, get, intersectionBy, map, sampleSize, size, zip, } = require("lodash");

const processItems = (items, context, importLogic, uniqueLogic, config) => {
    const displayedList = filter(items, item => jsonLogic.apply(get(item, 'displayLogic', true), context));

    // Create a reference list containing the displayable items with their sources. This is the list to be used from now on.
    const importedList = flatten(map(importLogic, item => map(item.input, entry => ({ name: entry.name, source: entry.source }))));
    const referenceList = map(displayedList, displayedItem => {
        const ref = find(importedList, { name: displayedItem.name });
        return { ...displayedItem, source: get(ref, 'source')};
    });

    const discardedList = flatten(map(importLogic, item => {
        // Filter out imported items which did not pass display logic
        const displayed = intersectionBy(item.input, items, 'name');

        // Out of these items, apply import logic to each
        const list = filter(displayed, item => jsonLogic.apply(item.logic, context));
        // If no limit defined default to list size
        const limit = get(item, 'limit', size(list));

        // If a subset is defined (through the "limit" property) generate a random list of such size
        // unless limit is turned off in which case we just return the same list
        const sampled = get(config, 'limit', false) ? sampleSize(list, limit) : list;

        // Now obtain the items to be discarded
        const discarded = differenceBy(item.input, sampled, 'name');
        return discarded;
    }));

    // Remove these items from the 
    const output = differenceBy(referenceList, discardedList, 'name');

    // Apply unique constraints unless this property is off
    const uniqueList = get(config, 'unique', false) ? zip(...uniqueLogic) : [];

    const discardedList2 = flatten(map(uniqueList, uniqueItem => {
        // First find remaining items containing the same source
        const mapped = map(uniqueItem, source => ({ source }));
        const intersected = intersectionBy(output, mapped, 'source');

        // If more than one such item exists, leave one randomly and add the rest to the list of items to be discarded
        const discarded = size(intersected) > 1 ? sampleSize(mapped, size(mapped) - 1) : [];
        return discarded;
    }));

    // Remove non-unique items from the remaining items
    const output2 = differenceBy(output, discardedList2, 'source');
    // console.log(output2);

    // Finally, return the original objects with no source fields, etc.
    return intersectionBy(displayedList, output2, 'name');
};

const processGroups = (question, context, config) => {
    const items = get(question, 'groups', []);
    const importLogic = get(question, 'importLogic', []);
    const uniqueLogic = get(question, 'uniqueLogic', []);

    const groups = processItems(items, context, importLogic, uniqueLogic, config);
    return groups;
};

const processOptions = (question, context, config) => {
    const items = get(question, 'options', []);
    const importLogic = get(question, 'importLogic', []);
    const uniqueLogic = get(question, 'uniqueLogic', []);

    const options = processItems(items, context, importLogic, uniqueLogic, config);
    return options;
};

export { processGroups, processOptions };
